import { Injectable } from '@angular/core';
import { BaseResolver } from '../../../shared/base-classes/base.resolver';
import { ScheduledHeroEventResponseDto } from '@whetstoneeducation/hero-common';
import { AppResolverErrorHandlerService } from '../../../shared/services/resolver-error-handler.service';
import { AppEventService } from '../events.service';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AppToastManagerService } from '../../../shared/services/toast-manager.service';

@Injectable({ providedIn: 'root' })
export class AppScheduledHeroEventViewEditResolver extends BaseResolver<ScheduledHeroEventResponseDto> {
  constructor(
    public resolverErrorHandler: AppResolverErrorHandlerService,
    public eventService: AppEventService,
    public router: Router,
    public toastService: AppToastManagerService
  ) {
    super(resolverErrorHandler);
  }

  async handleResolve(route: ActivatedRouteSnapshot) {
    const id = route.paramMap.get('id');
    const scheduledHeroEvent = await this.eventService.getScheduledHeroEvent(
      +id
    );

    if (!scheduledHeroEvent) {
      this.toastService.error('Issue retrieving scheduled event');
      await this.router.navigate(['/calendar']);
    }

    return scheduledHeroEvent;
  }
}
